/**
 * @file   : Advertise.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/11/2019, 11:11:00 AM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { throwError } from '../../actions/Application'
import { submitAdvertisingInquiryInline } from '../../actions/Backend'
import { errMsgs } from '../../constants/Errors'
import Cont from '../../external/components/layout/Cont'
import MetaData from '../../external/components/meta/MetaData'
import { createErrorFromObj, getErrors } from '../../utilities/ErrorUtils'
import { getLiteralValuesForApp } from '../../utilities/MetaDataUtils'
import AdvertiseLayout from './AdvertiseLayout'
import { receiveError } from '../../utilities/BackendUtils'

export const MODE_INQUIRY = 'inquiry'
export const MODE_COMPLETE = 'complete'
export const PAGE_ID = 'PAGE_ADVERTISE'

class AdvertiseContainer extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      validationRquestId: 0,
      mode: MODE_INQUIRY,
    }
  }

  onValidationRequest() {
    this.setState({
      ...this.state,
      validationRquestId: this.state.validationRquestId + 1,
    })
  }

  onValidation(validationRequestId, errorCount, data) {
    if (errorCount <= 0) {
      submitAdvertisingInquiryInline(
        data,
        this.onSubmitAdvertisingInquiryInlineResponse.bind(this),
      )
    } else {
      this.props.onGenerateValidationError()
    }
  }

  onSubmitAdvertisingInquiryInlineResponse(success, data) {
    if (success) {
      this.setState({
        ...this.state,
        mode: MODE_COMPLETE,
      })
    } else {
      this.props.onGenerateGeneralError(data)
    }
  }

  render() {
    const { theme, intl, errors, inquiry, mainConfig, metaConfig } = this.props

    return (
      <Cont>
        <MetaData
          intlObj={intl}
          literalValues={getLiteralValuesForApp(mainConfig)}
          data={metaConfig}
          pageId={PAGE_ID}
        />
        <AdvertiseLayout
          theme={theme}
          intl={intl}
          errors={errors}
          inquiry={inquiry}
          validationRquestId={this.state.validationRquestId}
          mode={this.state.mode}
          onValidationRequest={this.onValidationRequest.bind(this)}
          onValidation={this.onValidation.bind(this)}
          mainConfig={mainConfig}
        />
      </Cont>
    )
  }
}

const mapStateToProps = function (state, props) {
  return {
    theme: state.application.theme,
    intl: state.backend.intl,
    errors: getErrors(state.backend.error, state.application.error),
    inquiry: state.backend.advertise.inquiry,
    mainConfig: state.backend.config.main,
    metaConfig: state.backend.config.meta,
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    onGenerateValidationError: () => {
      dispatch(throwError(createErrorFromObj(errMsgs.formValidationFail)))
    },

    onGenerateGeneralError: (error) => {
      const err = {
        ...error,
        faults: error.faults.map(fault => ({ ...fault, isA1: true }))
      }
      
      dispatch(receiveError(err))
    },
  }
}

AdvertiseContainer.propTypes = {
  theme: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  inquiry: PropTypes.object.isRequired,
  onGenerateGeneralError: PropTypes.func.isRequired,
  onGenerateValidationError: PropTypes.func.isRequired,
  mainConfig: PropTypes.object.isRequired,
  metaConfig: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvertiseContainer)
